export enum HeaderTabs {
    MainDetails = 'mailDetails',
    FinanceProducts = 'financeProducts',
    InsuranceProducts = 'insuranceProducts',
    Authorization = 'authorization',
}
